export const GET_USERS_REQUESTED = 'GET_USERS_REQUESTED';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';
export const GET_USERS = 'GET_USERS';
export const SET_USERS = 'SET_USERS';
export const SUBSCRIPTION = 'SUBSCRIPTION';
export const PRE_PROCCESSED_MEDICAL_DATA = 'PRE_PROCCESSED_MEDICAL_DATA';
export const SHOULD_NEED_TO_PROCESSCASE = 'SHOULD_NEED_TO_PROCESSCASE'
export const SUMMARY_LOADING = 'SUMMARY_LOADING'
export const SAVE_PROGRESS = 'SAVE_PROGRESS'
export const CASE_DATA_FILES = {
    ADD_FILES: 'ADD_CASE_DATA_FILES',
    UPDATE_FILE: 'UPDATE_CASE_DATA_FILE',
    REMOVE_FILES: 'REMOVE_CASE_DATA_FILES',
    REMOVE_FILE: 'REMOVE_CASE_DATA_FILE',
};
export const TEMPLATE_SETTINGS = {
    SET_DEMAND_NAME_MAP: 'TEMPLATE_SETTINGS_SET_DEMAND_NAME_MAP',
};
export const FILE_UPLOAD_ACTIONS = {
    ADD_TO_QUEUE: 'FILE_UPLOAD_ADD_TO_QUEUE',
    START_UPLOAD: 'FILE_UPLOAD_START',
    UPDATE_PROGRESS: 'FILE_UPLOAD_UPDATE_PROGRESS',
    UPLOAD_SUCCESS: 'FILE_UPLOAD_SUCCESS',
    UPLOAD_FAILED: 'FILE_UPLOAD_FAILED',
    RETRY_UPLOAD: 'FILE_UPLOAD_RETRY',
    CANCEL_UPLOAD: 'FILE_UPLOAD_CANCEL',
    REMOVE_UPLOAD: 'FILE_UPLOAD_REMOVE',
    CLEAR_COMPLETED: 'FILE_UPLOAD_CLEAR_COMPLETED',
    TOGGLE_WIDGET: 'FILE_UPLOAD_TOGGLE_WIDGET',
    PRESIGNED_URL_GENERATION_START: 'PRESIGNED_URL_GENERATION_START',
    PRESIGNED_URL_GENERATION_COMPLETE: 'PRESIGNED_URL_GENERATION_COMPLETE',
};
